import { render, staticRenderFns } from "./iataPrice.vue?vue&type=template&id=7bed58ab&scoped=true&"
import script from "./iataPrice.vue?vue&type=script&lang=js&"
export * from "./iataPrice.vue?vue&type=script&lang=js&"
import style0 from "./iataPrice.vue?vue&type=style&index=0&id=7bed58ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bed58ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bed58ab')) {
      api.createRecord('7bed58ab', component.options)
    } else {
      api.reload('7bed58ab', component.options)
    }
    module.hot.accept("./iataPrice.vue?vue&type=template&id=7bed58ab&scoped=true&", function () {
      api.rerender('7bed58ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/iataPrice.vue"
export default component.exports